import lazyLoading from './lazyLoading'

export default [
  { name: 'home', path: '/', component: lazyLoading('Pages/Home') },
  { name: 'order', path: '/order', component: lazyLoading('Auth/Order') },
  { name: 'register', path: '/register', component: lazyLoading('Auth/Register') },
  { name: 'pages.preview', path: '/pages/:id/preview', component: lazyLoading('Pages/PagePreview') },
  { name: 'stripe.callback', path: '/auth/stripe_connect/callback', component: lazyLoading('Auth/StripeCallback') },
  { name: 'aweber.callback', path: '/auth/aweber/callback', component: lazyLoading('Auth/AweberCallback') },
  { name: 'keap.callback', path: '/auth/keap/callback', component: lazyLoading('Auth/KeapCallback') },
  { name: 'goto.callback', path: '/auth/goto/callback', component: lazyLoading('Auth/GoToCallback') },
  { name: 'adminblogs.show', path: '/admin-blog/:id', component: lazyLoading('Pages/AdminBlogShow') },
  { name: 'admin.pagetemplates.preview', path: '/page-templates/:pageTemplateId/preview', component: lazyLoading('Admin/PageTemplates/Preview') },
  { name: 'admin.templates.blogs.preview', path: '/templates/:templateId/blog/:blogId/preview', component: lazyLoading('Admin/TemplateBlogs/Preview') },
  { name: 'admin.templates.pages.preview', path: '/templates/:templateId/pages/:pageId/preview', component: lazyLoading('Admin/TemplatePages/Preview') },
  { name: 'admin.templates.preview', path: '/templates/:templateId/preview', component: lazyLoading('Admin/Templates/Preview') },
  { name: 'admin.orderpages.preview', path: '/admin/payment/order-pages/:orderPageId/preview', component: lazyLoading('Admin/OrderPage/Preview') },
  { name: 'agency.blogs.share', path: '/agency/blog/:uniqueId', component: lazyLoading('Agency/Blogs/Share') },
  { name: 'agency.pages.share', path: '/agency/pages/:uniqueId', component: lazyLoading('Agency/Pages/Share') },
  {
    name: 'admin.blogs.share',
    path: '/admin/blog/:uniqueId',
    component: lazyLoading('Admin/Blogs/Share'),
    beforeEnter: (to, from, next) => {
      ['create'].includes(to.params.uniqueId)
        ? next({ name: 'admin.blogs.create' })
        : next()
    }
  },
  { name: 'admin.courses.preview', path: '/admin/courses/:courseId/preview', component: lazyLoading('Admin/Courses/Preview') }
]